import { render, staticRenderFns } from "./EchartStat.vue?vue&type=template&id=01d008db&scoped=true"
import script from "./EchartStat.vue?vue&type=script&lang=js"
export * from "./EchartStat.vue?vue&type=script&lang=js"
import style0 from "./EchartStat.vue?vue&type=style&index=0&id=01d008db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d008db",
  null
  
)

export default component.exports